import React, { useState, useEffect, useContext } from "react";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from "@mui/material";
import TableAllData from "components/Content/CustomTable/TableAllData";
import TableStyle from "components/Content/Table/TableStyle.module.css";
import { AppContext } from "AppContext";
import { apiGet } from "app/Services/ApiService";
import { apiUrls } from "common/ApiUrls";
import { CloudDownloadOutlined } from "@mui/icons-material";
import { PrivateRoutesContext } from "app/PrivateRoutesContext";
import { Utils } from "common/Utils";
import ConfirmDialog from "components/Content/Modal/ConfirmDialog";
import AximTooltip from "components/AximTooltip";

function Files() {
  const { modalIsOpen, setModalIsOpen, companyId, setCompany } = useContext(PrivateRoutesContext);
  const [fetchedData, setFetchedData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [doShowError, setDoShowError] = useState(false);
  const [errorText, setErrorText] = useState("");

  const [doShowConfirm, setDoShowConfirm] = useState(false);
  const [confirmCloseAction, setConfirmCloseAction] = useState(null);
  const [confirmTitle, setConfirmTitle] = useState('');
  const [confirmText, setConfirmText] = useState('');
  const [confirmButtonsDisabled, setConfirmButtonsDiabled] = useState(false);

  const handleClose = () => {
    setDoShowError(false);
  }

  const columns = [
    {
      Header: "",
      accessor: "fileId",
      Cell: e =>
        <AximTooltip title="Download File">
          <IconButton onClick={() => promptDownloadFile(`${e.value}`, `${e.row.values.fileName}`)} color="primary"><CloudDownloadOutlined /></IconButton>
        </AximTooltip>,
      maxWidth: 100,
      disableFilters: true,
    },
    {
      Header: "File Name",
      accessor: "fileName",
    },
    {
      Header: "Update Date",
      accessor: (cell) => Utils.formatDate(cell.updateDate),
      Cell: ({ row }) => (
        <Box>
          {Utils.formatDate(row.original.updateDate)}
        </Box>
      ),
      sortType: "dateSort"
    },
    {
      Header: "Update By",
      accessor: "updateUser",
    },
  ];

  const getCompany = () => {
    let selectedCompany = localStorage.getItem(`selectedParentCompanyId`);
    console.log(`current company ${selectedCompany}`)
    if (selectedCompany == null || selectedCompany === "") {
      setModalIsOpen(true)
    }
    else {
      setCompany(selectedCompany, "AP3")
    }
    return selectedCompany
  }

  useEffect(() => {
    getCompany()
  }, []);

  useEffect(() => {
    handleChangeCompany()
  }, [companyId]);

  const handleChangeCompany = () => {
    let selectedCompany = getCompany()
    if (selectedCompany != null  && selectedCompany != "") {
      apiGet(apiUrls.getFiles(selectedCompany)).then(
        (response) => {
          // debugger
          setFetchedData(response.data);
        }
      )
      .finally(() => setIsLoading(false));
    }
  }

  const promptDownloadFile = (fileId, fileName) => {
    setConfirmCloseAction(() => (result) => downloadFile(result, fileId, fileName));
    setConfirmTitle('Download File');
    setConfirmText(`Are you sure you would like to download file?`);
    setDoShowConfirm(true);
  }

  const downloadFile = (isConfirmed, fileId, fileName) => {
    if (isConfirmed) {
      setConfirmButtonsDiabled(true);

      Utils.downloadFile(apiUrls.downloadFile(companyId, fileId),
        fileName,
        null,
        () => {
          setErrorText("An Error occurred downloading the file.");
          setDoShowError(true);
        },
        () => {
          setConfirmButtonsDiabled(false);
          setDoShowConfirm(false);
        });
    }
    else {
      setDoShowConfirm(false);
    }
  }

  return (
    <div >
      {/* <Topbar text="Files" /> */}
      <div className={TableStyle.tableWrapper}>
        <TableAllData columns={columns} data={fetchedData} isLoading={isLoading} download={{ prefix: "Files", table: "Files" }} />
      </div>
      <Dialog
        open={doShowError}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"An Error Occurred"}</DialogTitle>
        <DialogContent>
          {errorText}
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <ConfirmDialog
        doShowConfirm={doShowConfirm}
        handleClose={(result) => confirmCloseAction(result)}
        confirmTitle={confirmTitle}
        confirmText={confirmText}
        buttonsDisabled={confirmButtonsDisabled} />
    </div>
  );
}

export default Files;
